// Situações tributárias do ICMS aceitas pela Focus no CTe (mesma lista usada nos modais de emissão)
export const ICMS_SITUACOES_TRIBUTARIAS = [
  { value: '00', label: '00 - Tributada integralmente' },
  { value: '10', label: '10 - Tributada e com cobrança do ICMS por substituição tributária' },
  { value: '20', label: '20 - Tributada com redução de base de cálculo' },
  {
    value: '30',
    label: '30 - Isenta ou não tributada e com cobrança do ICMS por substituição tributária',
  },
  { value: '40', label: '40 - Isenta' },
  { value: '41', label: '41 - Não tributada' },
  { value: '50', label: '50 - Suspensão' },
  {
    value: '51',
    label:
      '51 - Diferimento (a exigência do preenchimento das informações do ICMS diferido fica a critério de cada UF)',
  },
  { value: '60', label: '60 - Cobrado anteriormente por substituição tributária' },
  {
    value: '70',
    label:
      '70 - Tributada com redução de base de cálculo e com cobrança do ICMS por substituição tributária',
  },
  { value: '90', label: '90 - Outros (Regime Normal)' },
  {
    value: '90_outra_uf',
    label:
      '90_outra_uf - Outros (ICMS devido à UF de origem da prestação, quando diferente da UF do emitente)',
  },
  { value: '90_simples_nacional', label: '90_simples_nacional - Outros (regime Simples Nacional)' },
]
